import React from "react";

function LinkSent() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <linearGradient
        id="a"
        x1="228.05"
        x2="2.6"
        y1="326.56"
        y2="-25.34"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C2CECE"></stop>
        <stop offset="1" stopColor="#97AAAA"></stop>
      </linearGradient>
      <path
        fill="url(#a)"
        d="M145.986 238.876L19.238 365.625c-25.65 25.65-25.65 67.238 0 92.889l34.25 34.25c25.65 25.65 67.238 25.65 92.889 0l126.749-126.749c25.65-25.65 25.65-67.238 0-92.889l-34.25-34.25c-25.652-25.651-67.239-25.651-92.89 0zM87.331 455.581l-30.912-30.912c-6.959-6.959-6.959-18.241 0-25.2L179.83 276.058c6.959-6.959 18.241-6.959 25.2 0l30.912 30.912c6.959 6.959 6.959 18.241 0 25.2l-123.41 123.411c-6.959 6.959-18.242 6.959-25.201 0z"
      ></path>
      <linearGradient
        id="b"
        x1="97.427"
        x2="167.017"
        y1="224.117"
        y2="154.537"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#363F3E" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#303033"></stop>
      </linearGradient>
      <path
        fill="url(#b)"
        d="M56.419 424.668c-6.959-6.959-6.959-18.241 0-25.2L179.83 276.057c6.959-6.959 18.241-6.959 25.2-.001l8.521-7.743-9.611-10.055c-14.347-14.347-37.607-14.347-51.955 0L46.974 363.268c-14.347 14.347-14.347 37.607 0 51.955l9.445 9.445z"
      ></path>
      <linearGradient
        id="c"
        x1="178.597"
        x2="203.917"
        y1="135.118"
        y2="109.798"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#363F3E" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#303033"></stop>
      </linearGradient>
      <path
        fill="url(#c)"
        d="M273.124 273.124l-28.535-28.535 5.714 5.714c25.65 25.65 25.65 67.238 0 92.889L123.554 469.94c-25.65 25.65-67.238 25.65-92.889 0l-5.714-5.714 28.535 28.535c25.65 25.65 67.238 25.65 92.889 0l126.749-126.749c25.651-25.649 25.651-67.236 0-92.888z"
      ></path>
      <linearGradient
        id="d"
        x1="222.354"
        x2="-3.096"
        y1="122.477"
        y2="117.606"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C2CECE"></stop>
        <stop offset="1" stopColor="#97AAAA"></stop>
      </linearGradient>
      <path fill="url(#d)" d="M64.51 432.759l-4.046-4.045 4.046 4.045z"></path>
      <linearGradient
        id="e"
        x1="374.038"
        x2="148.588"
        y1="438.939"
        y2="87.04"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C2CECE"></stop>
        <stop offset="1" stopColor="#97AAAA"></stop>
      </linearGradient>
      <path
        fill="url(#e)"
        d="M365.624 19.239L238.875 145.986c-25.65 25.65-25.65 67.238 0 92.889l34.25 34.25c25.65 25.65 67.238 25.65 92.889 0l126.749-126.749c25.65-25.65 25.65-67.238 0-92.889l-34.25-34.25c-25.651-25.65-67.239-25.65-92.889.002zm-58.656 216.705l-30.912-30.912c-6.959-6.959-6.959-18.241 0-25.2L399.467 56.419c6.959-6.959 18.241-6.959 25.2 0l30.912 30.912c6.959 6.959 6.959 18.241 0 25.2l-123.41 123.412c-6.959 6.96-18.242 6.96-25.201.001z"
      ></path>
      <linearGradient
        id="f"
        x1="299.347"
        x2="368.177"
        y1="426.188"
        y2="357.358"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#363F3E" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#303033"></stop>
      </linearGradient>
      <path
        fill="url(#f)"
        d="M276.056 205.031c-6.959-6.959-6.959-18.241 0-25.2L399.467 56.419c6.959-6.959 18.241-6.959 25.2-.001l-10.307-8.581c-14.347-14.347-37.607-14.347-51.955 0l-95.794 95.794c-14.347 14.347-14.347 37.607 0 51.955l9.445 9.445z"
      ></path>
      <linearGradient
        id="g"
        x1="384.507"
        x2="409.827"
        y1="341.028"
        y2="315.708"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#363F3E" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#303033"></stop>
      </linearGradient>
      <path
        fill="url(#g)"
        d="M492.762 53.487l-28.535-28.535 5.714 5.714c25.65 25.65 25.65 67.238 0 92.889l-126.75 126.749c-25.65 25.65-67.238 25.65-92.889 0l-5.714-5.714 28.535 28.535c25.65 25.65 67.238 25.65 92.889 0l126.749-126.749c25.651-25.651 25.651-67.238.001-92.889z"
      ></path>
      <linearGradient
        id="h"
        x1="222.45"
        x2="-3"
        y1="323.941"
        y2="319.071"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C2CECE"></stop>
        <stop offset="1" stopColor="#97AAAA"></stop>
      </linearGradient>
      <path
        fill="url(#h)"
        d="M284.147 213.121l-4.046-4.045 4.046 4.045z"
      ></path>
      <linearGradient
        id="i"
        x1="281.658"
        x2="227.448"
        y1="237.968"
        y2="292.178"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#363F3E" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#303033"></stop>
      </linearGradient>
      <path
        fill="url(#i)"
        d="M273.13 273.131c21.964 21.964 25.114 55.609 9.462 80.927l-22.827-22.827-21.717-21.717-5.259-5.259 32.029-32.029 3.711-3.697 3.697-3.711 32.029-32.029 49.803 49.803c-25.32 15.651-58.964 12.503-80.928-9.461z"
      ></path>
      <linearGradient
        id="j"
        x1="222.387"
        x2="247.727"
        y1="297.238"
        y2="271.898"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C2CECE"></stop>
        <stop offset="1" stopColor="#97AAAA"></stop>
      </linearGradient>
      <path
        fill="url(#j)"
        d="M318.23 193.802c-9.807-9.807-25.706-9.807-35.513 0 0 0-58.545 58.518-88.913 88.85-9.834 9.822-9.831 25.75-.003 35.579 9.807 9.807 25.706 9.807 35.513 0l88.916-88.916c9.806-9.808 9.806-25.707 0-35.513z"
      ></path>
      <linearGradient
        id="k"
        x1="245.737"
        x2="258.957"
        y1="273.887"
        y2="260.667"
        gradientTransform="matrix(1.0667 0 0 -1.0667 3.267 557.534)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#363F3E" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#303033"></stop>
      </linearGradient>
      <path
        fill="url(#k)"
        d="M318.23 193.802a25.08 25.08 0 00-5.707-4.262c5.222 9.534 3.812 21.731-4.262 29.806l-88.916 88.916c-8.076 8.076-20.275 9.485-29.81 4.26a25.131 25.131 0 004.266 5.709c9.807 9.807 25.706 9.807 35.513 0l88.916-88.916c9.807-9.808 9.807-25.707 0-35.513z"
      ></path>
    </svg>
  );
}

export default LinkSent;